import * as React from "react";

export function SubtractIcon({
  fill = "#1A2547",
  stroke = "#1A2547",
  strokeWidth = 2,
  onClick,
}: {
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  onClick?: () => void;
}): JSX.Element {
  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
        <rect x="1.50098" y="1.44922" width="11.4422" height="11.4422" rx="2.5" fill={fill} stroke={stroke} />
        <rect
          x="8.76953"
          y="7.76953"
          width="10.4422"
          height="10.4422"
          rx="2"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </svg>
    </div>
  );
}
